import httpRequest from '../network';
import { InternalAxiosRequestConfig } from 'axios';

const MODEL_NAME = 'sbx_audit';

/**
 * Represents an event in the SBX system.
 * This class is used to create and send events with user ID and sbx_crm information.
 */
export class SbxEvent {
  private sbxCrm: string;
  private appName = 'AI_STUDIO_'; // Default app name, can be overridden if needed

  /**
   * Creates an instance of SbxEvent.
   * @param {string} sbx_crm - The sbx_crm associated with the event.
   */
  constructor(sbx_crm?: string) {
    this.sbxCrm = sbx_crm || ''; // Default to empty string if not provided
  }

  /**
   * Sets the sbx_crm for the event.
   * @param {string} sbx_crm - The sbx_crm to set.
   */
  setSbxCrm(sbx_crm: string) {
    this.sbxCrm = sbx_crm;
  }

  /**
   * Sends an event to the server with the specified event name and metadata.
   * @param {Object} params - The parameters for sending the event.
   * @param {string} params.eventName - The name of the event to send.
   * @param {Record<string, any>} [params.metadata={}] - Additional metadata to include with the event.
   */
  public eventHandler({ eventName, metadata = {} }: { eventName: string; metadata?: Record<string, any> }) {
    const eventData = {
      user: this.sbxCrm,
      action: this.appName.concat(eventName.toUpperCase()),
      object_string: metadata.toJsonString(),
      date: new Date(),
    };

    try {
      httpRequest.POST(`/api/data/v1/row/${MODEL_NAME}`, eventData).then();
    } catch (error) {
      console.error('Error sending event:', error);
    }
  }

  test() {
    if (this.sbxCrm) {
      return true;
    }
    console.warn('SbxEvent: sbx_crm is not set. Please set it before sending events.');
    return false;
  }
}

const sbxEvent = new SbxEvent();

export default sbxEvent;

const omitUrls = ['model/find', 'model/find_all', 'sbx_audit', '/api/ai_agent/folder'];

export const sbxEventValidator = (req: InternalAxiosRequestConfig) => {
  if(omitUrls.some(url => req.url?.includes(url))) return;
  switch (req.method) {
    case 'post':
      sbxEvent.eventHandler({
        eventName: req.url?.includes('model/delete') ? 'DELETE' : 'CREATE',
        metadata: {
          ...(req.url?.includes('/api/data/v1/row/') ? {model: req.url?.split('/').pop() || ''} : {}),
          data: req.data,
          url: req.url,
        },
      });
      break;

    case 'put':
      sbxEvent.eventHandler({
        eventName: 'UPDATE',
        metadata: {
          data: req.data,
          url: req.url,
        },
      });

      break;

    case 'delete':
      sbxEvent.eventHandler({
        eventName: 'DELETE',
        metadata: {
          url: req.url,
        },
      });

      break;

    default:
      break;
  }
};
